// src/hooks/useRegisterDevice.ts
import { useEffect } from 'react';
import { Scalars, useRegisterDeviceMutation } from 'generated/graphql';
import { getFcmTokenFromSW } from 'serviceWorker';
import { getMessaging } from 'services/firebase'; // wrapper async vedi sotto

/**
 * Register (or update) the FCM device-token every time the user is logged-in.
 * @param enabled pass `true` only when the user is authenticated
 */
export function useRegisterDevice(enabled: boolean) {
  const [register] = useRegisterDeviceMutation();

  useEffect(() => {
    if (!enabled) return;
    let stop = false;
    let unsubscribeRefresh: (() => void) | null = null;

    /* 1️⃣  richiesta permesso + token iniziale ------------------------- */
    (async () => {
      const messaging = await getMessaging(); // null su Safari
      if (!messaging) {
        console.info('Push non supportato su questo browser');
        return;
      }

      if (Notification.permission !== 'granted') {
        const res = await Notification.requestPermission();
        if (res !== 'granted') return;
      }

      const token = await getFcmTokenFromSW();
      console.log('Device token:', token);
      if (stop || !token) return;
      try {
        await register({
          variables: { input: { token: token as Scalars['String'] } },
        });
        console.log('Device registered!', token);
      } catch (err) {
        console.error('registerDevice mutation failed', err);
      }

      /* 2️⃣  token rotation listener (v8 compat) ----------------------- */
      // @ts-ignore – proprietà privata ma funziona con compat v8
      unsubscribeRefresh = messaging.onTokenRefresh(async () => {
        const newToken = await getFcmTokenFromSW();
        if (stop || !newToken) return;

        await register({
          variables: { input: { token: newToken as Scalars['String'] } },
        });
        console.log('Device re-registered with new token:', newToken);
      });
    })();

    /* cleanup --------------------------------------------------------- */
    return () => {
      stop = true;
      if (unsubscribeRefresh) unsubscribeRefresh();
    };
  }, [enabled, register]);
}
